import { atom } from "recoil";
import { LoginScreenDetails } from "../dataDefinitions/loginScreenDetails";
import { RequestState } from "../dataDefinitions/request";
import { getDefaultRSObject } from "../apiClient";

export const loginScreenDetailsAtom = atom<RequestState<LoginScreenDetails>>({
    key: 'loginScreenDetails',
    default: getDefaultRSObject(),
})